import { BaseContractShim } from './BaseContractShim';
import LocalhostAbi from '@towns-protocol/generated/dev/abis/IERC721AQueryable.abi.json' assert { type: 'json' };
export class IERC721AQueryableShim extends BaseContractShim {
    constructor(address, provider) {
        super(address, provider, LocalhostAbi);
    }
}
//# sourceMappingURL=IERC721AQueryableShim.js.map